import { render } from "./video-watch.vue?vue&type=template&id=55a5905d&scoped=true"
import script from "./video-watch.vue?vue&type=script&lang=js"
export * from "./video-watch.vue?vue&type=script&lang=js"

import "./video-watch.vue?vue&type=style&index=0&id=55a5905d&scoped=true&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a5905d"]])

export default __exports__